import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiService from "services/ApiService";
import { signOut } from "./authSlice";

export const initialState = {
  items: [],
  loading: false,
  loadError: null,
  error: null,
};

export const fetchReports = createAsyncThunk(
  "reporting/fetchReports",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiService.getGlobalSettings({ type: "adminReporting" });
      const data = response?.data?.data;
      if (response?.status !== 200 || !response.data?.success || !Array.isArray(data?.[0]?.values)) {
        return rejectWithValue(response?.data || "Invalid reports response");
      }
      return data?.[0]?.values;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Unable to retrieve reports");
    }
  },
);

export const updateReports = createAsyncThunk(
  "reporting/updateReports",
  async (reports, { rejectWithValue }) => {
    try {
      const values = reports.map(({ id, name }) => ({ id: id.trim(), name: name.trim() }));
      const response = await ApiService.updateAdminReporting(values);
      if (response?.status !== 200 || !response.data?.success) {
        return rejectWithValue(response?.data || "Unable to save reports");
      }
      return values;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Unable to save reports");
    }
  },
);

const reportingSlice = createSlice({
  name: "reporting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state) => {
        state.loading = true;
        state.loadError = null;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.loading = false;
        state.loadError = action.payload || action.error.message;
      })
      .addCase(updateReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateReports.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(updateReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(signOut.fulfilled, () => initialState);
  },
});

export default reportingSlice.reducer;
